// extracted by mini-css-extract-plugin
export default {"wrapper":"Appointment_wrapper__r+XVC","col1":"Appointment_col1__wcTFe","col2":"Appointment_col2__ZCak5","col3":"Appointment_col3__vc-TR"};